import { List, Page } from "shared/react";
import { FOLLOWING_MAX } from "shared/schema";
import { useQuery } from "../util/db.js";
import { USER } from "../util/user.js";
import { FollowsYouNotice } from "./FollowsYouNotice.js";
import { ProfileCard } from "./ProfileCard.js";

export function RequestsPage(): React.ReactElement {
	const followed = USER.data.uid;
	return (
		<Page>
			<header>
				<h1>Follow requests</h1>
			</header>
			<section>
				<List //
					store={useQuery("following", { followed, status: "requested", $order: "!updated", $limit: FOLLOWING_MAX })}
					mapper={({ follower }) => (
						<article className="flex-column gap-hairline width-narrow">
							<ProfileCard key={follower} uid={follower} />
							<FollowsYouNotice follower={follower} />
						</article>
					)}
					more="Show more requests"
					empty="No requests"
				/>
			</section>
		</Page>
	);
}
